import { IconButton, IconButtonProps } from "@chakra-ui/button";
import { ArrowUpIcon } from "@chakra-ui/icons";
import React from "react";

export const MobileTopButton = React.forwardRef(
  (props: IconButtonProps, ref: React.Ref<any>) => {
    const scrollToTop = () => {
      //get element with id of 'main-container' and scroll to top of that container
      const mainContainer = document.getElementById("main-container");
      mainContainer?.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
      <IconButton
        onClick={() => scrollToTop()}
        ref={ref}
        display={{ base: "flex", lg: "none" }}
        fontSize="24px"
        variant="ghost"
        position="fixed"
        bottom={3}
        right={3}
        zIndex={100}
        icon={<ArrowUpIcon />}
        backgroundColor="brand.500"
        _hover={{ backgroundColor: "brand.400" }}
        _active={{ backgroundColor: "brand.500" }}
        color="white"
        borderRadius="50%"
        height={14}
        width={14}
        {...props}
      />
    );
  }
);
